import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        cari: {
            aktif: {},
            liste: []
        },
        stok: {
            aktif: {},
            liste: []
        },
        hesap: {},
        satis: [],
        sevk: [],
        basket: [],
        takip: [], // sepet bakiye sipariş
        loading: [false, 'Bekleyiniz'],
        bekle2: false,
        menu: false,
        foy: {},
        virtualRecord: {
            proforma: {},
        },
    },
    mutations: {

        setLoading(state, payLoad) {
            state.loading = payLoad
        },
        setMenu(state, payLoad) {
            state.menu = payLoad
        },
        setCari(state, payLoad) {
            state.cari[payLoad.nereye] = payLoad.data;
            console.log(payLoad)

            if (!state.virtualRecord.proforma[payLoad.data.kod]) state.virtualRecord.proforma[payLoad.data.kod] = []
            // if (payLoad.nereye == 'aktif') {
            //     state.stok.liste = []
            // }
        },
        setStok(state, payLoad) {
            state.stok[payLoad.nereye] = payLoad.data
        },
        pushStok(state, payload) {
            state.stok.liste.push(payload.data)
        },
        setHesap(state, payLoad) {
            state.hesap = payLoad
        },
        setDepomiktar(state, payLoad) {
            state.stok.aktif.depomiktar = payLoad
        },
        updateBasket(state, payLoad) {
            state.cari.aktif[payLoad.nerden] = parseInt(state.cari.aktif[payLoad.nerden] + payLoad.adet)
        },
        setBasket(state, payLoad) {
            state.basket = payLoad
        },
        setSatis(state, payLoad) {
            state.satis = payLoad
        },
        setSevk(state, payLoad) {
            state.sevk = payLoad
        },
        setTakip(state, payLoad) {
            state.takip = payLoad
        },
        bekle2(state, payLoad) { // iç bekle
            state.bekle2 = payLoad
        },
        setfoy(state, payLoad) { // son girilen föy detay
            state.foy = payLoad
        },
        addVirtual(state, payLoad) {
            //db den gelirken set edilme mantığı da böyle olacak
            state.virtualRecord.proforma[state.cari.aktif.kod].push(payLoad)
        },
        deleteVirtual(state, payLoad) {
            //db den gelirken set edilme mantığı da böyle olacak
            state.virtualRecord.proforma[state.cari.aktif.kod].splice(payLoad.index, 1)
        },
        updateVirtual(state, payLoad) {
            if (payLoad.islem == 'arttir') {
                state.virtualRecord[payLoad.virtual][state.cari.aktif.kod][payLoad.index].adet2++
                state.virtualRecord[payLoad.virtual][state.cari.aktif.kod][payLoad.index].satirupdateTarih = payLoad.tarih
            }
            else if (payLoad.islem == 'fiyat') {
                state.virtualRecord[payLoad.virtual][state.cari.aktif.kod][payLoad.index].fiyat.maliyet = payLoad.value

            }
            else {
                state.virtualRecord[payLoad.virtual][state.cari.aktif.kod][payLoad.index].adet2--
                state.virtualRecord[payLoad.virtual][state.cari.aktif.kod][payLoad.index].satirupdateTarih = payLoad.tarih
            }
        },

    },
    actions: {
        addVirtual(vCtx, payload) {
            vCtx.commit('addVirtual', payload)
        },
        updateVirtual(vCtx, payload) {
            vCtx.commit('updateVirtual', payload)
        },
        deleteVirtual(vCtx, payload) {
            vCtx.commit('deleteVirtual', payload)
        },
        setMenu(context, payload) {
            console.log(payload)
            context.commit("setMenu", payload)
        },
        stoklist(context, payload) {
            if (payload.sayfa == 1) {
                context.commit('setStok', { data: payload.data, nereye: 'liste' })
            }
            else {
                payload.data.forEach(element => {
                    context.commit('pushStok', { data: element, nereye: 'liste' })
                });
            }
        },
        setStok(context, payload) {
            context.commit('setStok', payload)
        },
        addstokHareket(context, payload) {

            return new Promise((resolve, reject) => {
                let source = context.getters.getHesap
                let giden = [];
                giden.push(payload.obje)
                payload.request.post(source.program + "/sh/add/", giden, context.getters.getHesap)
                    .then((res) => {
                        if (res.status == 200) {
                            resolve({ status: 200, id: res.id })
                        }
                        else if (res.status == 500) {

                            reject({ status: 500, mesaj: err.message })


                        }
                        else { reject({ status: 309, mesaj: "Yetkilendirme Hatası" }) }
                    })
                    .catch((err) => {
                        reject({ status: 500, mesaj: err.message })
                    });
            });
        },
        getFiles(context, payload) {

            return new Promise((resolve, reject) => {
                let source = context.getters.getHesap
                payload.request.post("crm/files/readdir/", {
                    folder: payload.folder,
                },
                    context.getters.getHesap
                )
                    .then((res) => {
                        resolve({ status: true, data: res.data })
                    })
                    .catch((err) => {
                        reject({ status: false, mesaj: err.message })
                    });
            });
        },
        setCari(context, payload) {
            context.commit('setCari', { data: payload.data, nereye: payload.nereye })
        },
        carilist(context, request) {

            return new Promise((resolve, reject) => {
                let source = context.getters.getHesap
                request.post(source.program + "/cariliste/", {
                    pkod: source.entegrekodu,
                    ckod: 0,
                    search: null,
                    sayfa: 1,
                    toplam: 0,
                },
                    context.getters.getHesap
                )
                    .then((carilist) => {
                        if (carilist.status == 200) {
                            context.commit('setCari', { data: carilist.response, nereye: 'liste' })
                            resolve({ status: true, mesaj: '' })
                        }
                        else {
                            reject({ status: false, mesaj: carilist.message })
                        }

                    })
                    .catch((err) => {
                        reject({ status: false, mesaj: err.message })
                    });
            });
        },
        sepetupdate(context, obj) {
            context.commit("setLoading", true)
            let source = obj.obje;
            let obje = { giden: obj.helper.point(context.getters.getCari.aktif.kod, [], [], [], source.guid, '', 1, 0, 0, 0, 'isim', 'asc', 1), adet: source.adet, durum: source.durum }
            obj.req
                .post("basket/update/", obje)
                .then((res2) => {
                    context.commit("setLoading", false)
                    context.commit("bekle2", false)

                    if (res2.status == 200) {
                        source.sepetadet = 0;
                        obj.notify({ type: 'success', message: res2.mesaj });
                        source.sepetadet = res2.yeniadet;
                        context.commit("bekle2", false)

                    } else if (res2.status == 301) {
                        obj.dialog.confirm({
                            title: res2.mesaj,
                            message: res2.mesaj2,
                        })
                        context.commit("bekle2", false)

                    }
                });
        },
        sepetekle(context, obj) {
            context.commit("setLoading", true)
            let source = obj.obje;
            let obje = { giden: obj.helper.point(context.getters.getCari.aktif.kod, [], [], [], source.guid, '', 1, 0, 0, 0, 'isim', 'asc', 1), adet: source.adet, durum: source.durum }
            obj.req
                .post("basket/add/", obje)
                .then((res) => {
                    context.commit("setLoading", false)
                    if (res.status == 200) {
                        context.commit('updateBasket', { nerden: res.nerden, adet: +1 })
                        obj.notify({ type: 'success', message: res.mesaj });
                        context.getters.getCari.aktif.success + 1
                        source.nerden = res.nerden;
                        source.sepetadet = res.yeniadet;
                        context.commit("bekle2", false)

                    } else if (res.status == 302) {

                        obj.dialog.confirm({
                            title: res.mesaj,
                            message: res.mesaj2,
                        }).then(() => {
                            context.dispatch("sepetupdate", obj);
                            context.commit("bekle2", false)
                        });

                    } else if (res.status == 301) {

                        obj.dialog.confirm({
                            title: res.mesaj,
                            message: res.mesaj2,
                        })
                        context.commit("bekle2", false)


                    } else if (res.status == 305) {
                        obj.notify({ type: 'warning', message: res.mesaj });
                        context.commit("bekle2", false)

                    } else {
                        obj.dialog.confirm({
                            title: res.mesaj,
                            message: res.mesaj2,
                        })
                        context.commit("bekle2", false)

                    }
                });
        },
        durumkontrol(context, obje) {
            context.commit("bekle2", true)
            if (context.getters.getCari.aktif.kod != 0 && context.getters.getCari.aktif.kod != undefined) {
                let source = obje.obje;
                if (source.adet > 0) {
                    if (source.durum == 1 || source.durum == 2) {
                        context.dispatch("sepetekle", obje)
                    } else {
                        if (source.sepetadet > 0) {
                            context.dispatch("sepetupdate", obje)
                        } else {
                            obje.dialog.confirm({
                                title: "Stok müsait değil",
                                message: "İzin verilmiiyor",
                            }).then(() => {
                                //context.dispatch("sepetekle", obje)
                            }).catch(() => {
                            });
                        }
                    }
                }
                else {
                    context.commit("bekle2", false)

                    obje.notify({ type: 'danger', message: 'Miktar 0 olamaz', duration: 2000 });
                }
            }
            else {
                context.commit("bekle2", false)

                obje.notify({ type: 'danger', message: 'Müşteri Seçilmemiş', duration: 2000 });
            }
        },
        deletebasket(context, obj) {

            let obje = {
                cKod: context.getters.getCari.aktif.kod,
                guid: obj.guid,
                nerden: obj.nerden,
            }
            this.$dialog.confirm({
                title: "Geri alınamaz",
                message: "Eminmisiniz ?",
            }).then(() => {
                this.$request
                    .post("basket/delete/", obje)
                    .then((res2) => {
                        if (res2.status) {
                            context.getters.getCari.aktif.success--;
                            obj.sepetadet = 0;

                            this.$notify({ type: 'success', message: "İşlem Başarılı" });
                        } else {
                            this.$notify({ type: 'danger', message: "Tekrar Deneyiniz" });
                        }
                    });
            });

        },
        depobul(context, payLoad) {
            context.getters.getBasket
        },
        upload(context, payload) {


            return new Promise((resolve, reject) => {
                let source = context.getters.getHesap
                let giden = {
                    list: payload.list,
                    dir: payload.dir
                }

                payload.request.post(source.program + "/files/create/", giden, context.getters.getHesap)
                    .then((res) => {
                        resolve({ status: true, id: res.id })
                    })
                    .catch((err) => {
                        reject({ status: false, mesaj: err.message })
                    });
            });
        },
        foydetay(context, payload) {
            console.log(payload)
            context.commit("setfoy", payload)
        },
    },
    getters: {
        getHesap(state) {
            return state.hesap
        },
        getCari(state) {
            return state.cari
        },
        getStok(state) {
            return state.stok
        },
        getBasket(state) {
            return state.basket
        },
        getSatis(state) {
            return state.satis
        },
        getSevk(state) {
            return state.sevk
        },
        getTakip(state) {
            return state.takip
        },
        getLoading(state) {
            return state.loading
        },
        getbekle2(state) { // iç bekle 
            return state.bekle2
        },
        getMenu(state) {
            return state.menu
        },
        getFoy(state) {
            return state.foy
        },
        getVirtual(state) {
            return state.virtualRecord
        },
    },
    plugins: [vuexLocal.plugin]

})


// WEBPACK FOOTER //
// ./src/store/index.js